namespace GeniuzPOS.PosShift {
    export interface LogFuctionLvAppRow {
        Id?: number;
        UnlockFor?: string;
        CashierLv?: number;
        ShiftId?: string;
        FuncId?: string;
        AppCashier?: string;
        AppCashierLv?: number;
        PosId?: string;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace LogFuctionLvAppRow {
        export const idProperty = 'Id';
        export const nameProperty = 'FuncId';
        export const localTextPrefix = 'PosShift.LogFuctionLvApp';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            UnlockFor = "UnlockFor",
            CashierLv = "CashierLv",
            ShiftId = "ShiftId",
            FuncId = "FuncId",
            AppCashier = "AppCashier",
            AppCashierLv = "AppCashierLv",
            PosId = "PosId",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
